import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import MobilePurchasePlans from './mobilePurchasePlans';
import DesktopPurchasePlans from './desktopPurchasePlans';
import styles from './_purchasePlans.module.scss';

const planData = {
  title: 'Savings plans can be setup with all major banks',
  footerText: 'and over 50 others',
};

class PurchasePlans extends Component {
  render() {
    return (
      <>
        <div className={cx(styles['purchase-plans-page-container'])}>
          <div className={styles['mobile']}>
            <MobilePurchasePlans planData={planData} />
          </div>
          <div className={styles['desktop']}>
            <DesktopPurchasePlans planData={planData} />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(PurchasePlans);
